// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CompleteStageMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  stage: Types.Stage;
}>;


export type CompleteStageMutation = { __typename?: 'Mutation', completeStage: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };


export const CompleteStageDocument = gql`
    mutation CompleteStage($projectId: ID!, $stage: Stage!) {
  completeStage(input: {projectId: $projectId, stage: $stage}) {
    emptyResult
  }
}
    `;
export type CompleteStageMutationFn = Apollo.MutationFunction<CompleteStageMutation, CompleteStageMutationVariables>;

/**
 * __useCompleteStageMutation__
 *
 * To run a mutation, you first call `useCompleteStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeStageMutation, { data, loading, error }] = useCompleteStageMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useCompleteStageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteStageMutation, CompleteStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteStageMutation, CompleteStageMutationVariables>(CompleteStageDocument, options);
      }
export type CompleteStageMutationHookResult = ReturnType<typeof useCompleteStageMutation>;
export type CompleteStageMutationResult = Apollo.MutationResult<CompleteStageMutation>;
export type CompleteStageMutationOptions = Apollo.BaseMutationOptions<CompleteStageMutation, CompleteStageMutationVariables>;